export const footer = {
  sponsor: {
    coOrganize: '合辦機構',
    agency: '捐助機構',
  },
}
